import CpEditFacilities from './cp-edit-facilities'

export default CpEditFacilities
